import { type HttpErrorResponse } from '@angular/common/http';
import { type IncidentDto } from '@api/incidents';
import { createEntityAdapter, type EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { IncidentsActions } from './incidents.actions';

export interface IncidentsState extends EntityState<IncidentDto> {
  error: HttpErrorResponse | null;
  isLoaded: boolean;
}

export const incidentsAdapter = createEntityAdapter<IncidentDto>({});

export const initialIncidentsState: IncidentsState = incidentsAdapter.getInitialState({
  error: null,
  isLoaded: false,
});

export const incidentsReducer = createReducer(
  initialIncidentsState,
  on(IncidentsActions.loadAllIncidents, state => {
    return {
      ...state,
      error: null,
    };
  }),
  on(IncidentsActions.loadAllIncidentSuccess, (state, action) => {
    return incidentsAdapter.setAll(action.incidents, {
      ...state,
      isLoaded: true,
    });
  }),
  on(IncidentsActions.loadAllIncidentError, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  }),
  on(IncidentsActions.resetIncidents, () => {
    return initialIncidentsState;
  }),
  on(IncidentsActions.addIncident, (state, action) => incidentsAdapter.setOne(action.incident, state)),
  on(IncidentsActions.resolveIncidents, (state, action) => {
      if (action.incidents) {
        return incidentsAdapter.removeMany(
          action.incidents.map(incident => incident.id),
          state,
        );
      }

      return state;
    },
  ),
);
